import React from "react";
import './TermsPage.css';
import HeaderView from '../../components/HeaderView';
import FooterView from '../../components/FooterView';
import TermsContent from './TermsView';

const TermsPage = () => {
    return (
        <div className="container">
            <HeaderView />
            <TermsContent />
            <FooterView />
        </div>
    );
};

export default TermsPage;
